class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainContent = null;
    this.isIpad = this.checkIfIpad();
    this.boundHandlers = {
      toggleBlur: this.toggleBlur.bind(this),
    };
  }

  connectedCallback() {
    this.mainContent = document.querySelector("#MainContent");
    this.toggleEventListeners(true);

    /*[LUX-731] On iPads, optimize the management of the megamenu; if clicking is not possible, the browser triggers a focus event. */
    if (this.isIpad) {
      this.querySelector("a")?.classList.add("tw-pointer-events-none");
    }
  }

  disconnectedCallback() {
    this.toggleEventListeners(false);
  }

  toggleEventListeners(enable) {
    const method = enable ? "addEventListener" : "removeEventListener";
    this[method]("mouseenter", this.boundHandlers.toggleBlur);
    this[method]("mouseleave", this.boundHandlers.toggleBlur);
  }

  toggleBlur(event) {
    this.mainContent?.classList.toggle("tw-custom-blur", event.type === "mouseenter");
  }

  checkIfIpad() {
    return window.matchMedia("(min-width: 1024px) and (hover: none)").matches;
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.mainDetailsToggle = this.querySelector('details');
  }

  onToggle() {
    if (!this.header) return;
    this.isClosing = true;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
